<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Sample Results Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading>
      <span class="float-left mr-2">{{ sample.publicNumber() }}</span>
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <status-progress
      :current_status="current_status"
      :log_collection="sample_status_logs"
      status_group="sample"
      class="mb-3"
    />
    <sample-card :sample="sample" />
    <permission-alert-gate
      :permissions="[
        'list analyte result',
        'add analyte result',
        'edit analyte result',
      ]"
    >
      <template #gated-content>
        <b-row class="mb-3">
          <b-col class="font-2xl">Results</b-col>
          <b-col cols="2">
            <b-button block variant="success" @click="addResult"
              ><i class="fa fa-plus" /> Add Result</b-button
            >
          </b-col>
        </b-row>
        <b-tabs>
          <b-tab title="Prep">
            <sample-editable-result-table
              :task_type="'Prep'"
              :status_collection="analyte_result_status_collection"
            />
          </b-tab>
          <b-tab title="Test">
            <sample-editable-result-table
              :task_type="'Test'"
              :status_collection="analyte_result_status_collection"
            />
          </b-tab>
        </b-tabs>
      </template>
    </permission-alert-gate>
  </div>
</template>
<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import SampleCard from "@/components/lab/sample/SampleCard";
import SampleEditableResultTable from "@/components/lab/sample/SampleEditableResultTable";
import StatusProgress from "@/components/shared/StatusProgress";
import { getCollection, getModel } from "@/shared/fetch-utils";

export default {
  name: "SampleResultsEdit",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    SampleCard,
    SampleEditableResultTable,
    StatusProgress,
  },
  data() {
    return {
      loading: true,
      sample: null,
      sample_id: this.$route.params.sample_id || null,
      analyte_result_status_collection: null,
      sample_status_logs: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/samples",
            title: "Sample list",
          },
          {
            icon: "fa-eye",
            title: "To Sample",
            variant: "info",
            linkto: `/samples/${this.sample_id}`,
          },
        ],
      };
    },
    current_status() {
      return (
        this.sample &&
        this.sample.current_sample_status_log.sample_status.status
      );
    },
  },
  methods: {
    addResult() {
      this.$router.push(`/samples/${this.sample_id}/results/add`);
    },
    async init() {
      this.sample = await getModel({
        model_type: "sample",
        id: this.sample_id,
        message: this.$bvToast,
      });
      this.analyte_result_status_collection = await getCollection({
        collection_type: "analyte_result_status",
        message: this.$bvToast,
      });

      this.sample_status_logs = this.sample.getSampleStatusLogs();
      this.loading = false;
    },
  },
  created() {
    this.loading = true;

    this.init();
  },
};
</script>
